export class Note {
    public createdDate: Date;
    public createdBy: string;
    public content: string;
}